import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KeycloakAdminApi } from '../../services/keycloak-admin-api';

@Component({
  selector: 'app-realm-overview',
  imports: [RouterLink],
  templateUrl: './realm-overview.html',
  styleUrl: './realm-overview.scss',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RealmOverview implements OnInit {
  canManageRealms = signal(false);
  canQueryClients = signal(false);
  canQueryUsers = signal(false);
  canQueryGroups = signal(false);

  private keycloakApi = inject(KeycloakAdminApi);

  async ngOnInit() {
    // isRealmAdmin is authoritative from the backend, not derived from JWT roles here
    const detailPermissions = await this.keycloakApi.getMe();
    if (detailPermissions.isRealmAdmin) {
      this.canManageRealms.set(true);
      this.canQueryClients.set(true);
      this.canQueryUsers.set(true);
      this.canQueryGroups.set(true);
    } else {
      this.canQueryClients.set(detailPermissions.accessibleClients.length > 0);
      const hasAtLeastOneIaUsersPerm = !!detailPermissions.accessibleClients.find(
        (ac) => !!ac.permissions?.find((perm) => 'ia_users' === perm)
      );
      this.canQueryUsers.set(hasAtLeastOneIaUsersPerm);
      this.canQueryGroups.set(hasAtLeastOneIaUsersPerm);
    }
  }
}
